import { render, staticRenderFns } from "./EsNotificationBubble.vue?vue&type=template&id=9bf46cc0&scoped=true&"
import script from "./EsNotificationBubble.vue?vue&type=script&lang=ts&"
export * from "./EsNotificationBubble.vue?vue&type=script&lang=ts&"
import style0 from "./EsNotificationBubble.vue?vue&type=style&index=0&id=9bf46cc0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf46cc0",
  null
  
)

export default component.exports